/**
 * CherishLink analytics — thin wrapper over PostHog (loaded in index.html).
 * Safe: all calls are no-ops if posthog isn't ready.
 */

const ph = () => (typeof window !== "undefined" ? window.posthog : null);

export function track(event, props = {}) {
  try {
    const p = ph();
    if (p && typeof p.capture === "function") {
      p.capture(event, props);
    }
    // also echo to console in dev for visibility
    if (typeof window !== "undefined" && window.location?.hostname?.includes("preview.emergentagent")) {
      // eslint-disable-next-line no-console
      console.debug("[analytics]", event, props);
    }
  } catch (e) {
    // swallow — analytics must never break UX
  }
}

export function identify(userId, traits = {}) {
  try {
    const p = ph();
    if (p && typeof p.identify === "function") {
      p.identify(userId, traits);
    }
  } catch (e) {}
}

export function reset() {
  try {
    const p = ph();
    if (p && typeof p.reset === "function") {
      p.reset();
    }
  } catch (e) {}
}

// Canonical event names — use these constants to avoid typos.
export const EVENTS = {
  // Landing
  LANDING_CTA_CLICKED: "landing_cta_clicked",
  PRICING_VIEWED: "pricing_viewed",
  AUDIO_SAMPLE_PLAYED: "audio_sample_played",
  // Auth
  SIGNUP_COMPLETED: "signup_completed",
  LOGIN_COMPLETED: "login_completed",
  DEMO_LOGIN_USED: "demo_login_used",
  // Onboarding
  ONBOARDING_COMPLETED: "onboarding_completed",
  // Billing
  CHECKOUT_STARTED: "checkout_started",
  CHECKOUT_COMPLETED: "checkout_completed",
  CHECKOUT_ABANDONED: "checkout_abandoned",
  PLAN_CHANGED: "plan_changed",
  SUBSCRIPTION_CANCELED: "subscription_canceled",
  // Calls
  CALL_SIMULATED: "call_simulated",
  CALL_COMPLETED: "call_completed",
  // Test call (Feature 1 growth)
  TEST_CALL_CTA_VIEWED: "test_call_cta_viewed",
  TEST_CALL_REQUESTED: "test_call_requested",
  TEST_CALL_BLOCKED_SAFELIST: "test_call_blocked_safelist",
  TEST_CALL_COMPLETED: "test_call_completed",
  TEST_CALL_FAILED: "test_call_failed",
  TEST_CALL_TO_SIGNUP: "test_call_to_signup",
  TEST_CALL_TO_PAID: "test_call_to_paid",
  // Kinvanta waitlist (Feature 2 growth)
  KINVANTA_WAITLIST_VIEWED: "kinvanta_waitlist_viewed",
  KINVANTA_WAITLIST_STARTED: "kinvanta_waitlist_started",
  KINVANTA_WAITLIST_JOINED: "kinvanta_waitlist_joined",
  KINVANTA_WAITLIST_DUPLICATE: "kinvanta_waitlist_duplicate",
};
